"use client";
import { cn } from "@/lib/utils/utils";
import { motion } from "motion/react";

const Loading = () => {
  const delay = 0.2;
  return (
    <motion.div
      className={cn(
        "fixed flex place-items-center justify-center top-0 right-0 left-0 bottom-0 bg-loader w-full z-999999 bg-background",
      )}
      initial={{ height: 0, bottom: 0 }}
      animate={{ height: "100%", top: 0 }}
    >
      <div className="flex flex-row flex-wrap items-center justify-center gap-1 max-w-[140px] ">
        {Array.from({ length: 6 }, (_, index) => {
          return (
            <motion.div
              key={`key-${index + 1}`}
              className="h-10 w-10 bg-accent"
              variants={variants}
              initial={"start"}
              animate={"end"}
              transition={{
                delay: delay * index,
                repeat: Infinity,
                duration: 0.5,
                repeatType: "reverse",
              }}
            />
          );
        })}
      </div>
    </motion.div>
  );
};

const variants = {
  start: {
    scale: 0.2,
    opacity: 0.2,
  },
  end: {
    scale: 1,
    opacity: 1,
  },
};

export default Loading;
